<template>
  <div>
    <video
      class="template__video"
      ref="video"
      webkit-playsinline="true"
      playsinline="true"
      autoplay="true"
      muted="muted"
      @canplay="updatePaused"
      @playing="updatePaused2"
      @pause="updatePaused"
      @ended="end = true"
      :key="videoPath.mp4"
    >
      <source :src="videoPath.mp4" type="video/mp4">
    </video>
    <div class="controls" :class="{ controls_show: end }">
      <div v-show="paused" @click="play" class="controls__wrap">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'controls__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 6.8c0-.2.1-.4.2-.5.3-.5.9-.6 1.4-.3l8.1 5.2.3.3c.3.5.2 1.1-.3 1.4L9.5 18c-.2.1-.3.2-.5.2-.6 0-1-.4-1-1z"/></svg>
      </div>
      <div v-show="playing" @click="pause" class="controls__wrap">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'controls__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.9 17.7c-.2 0-.4-.2-.4-.4V6.8c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v10.5c0 .2-.2.4-.4.4H7.9z"/><path d="M9.4 6.8v10.4H8V6.8h1.4m.1-1H7.9c-.5 0-.9.4-.9 1v10.5c0 .5.4.9.9.9h1.5c.5 0 .9-.4.9-.9V6.8c.1-.6-.3-1-.8-1z"/><g><path d="M14.5 17.7c-.2 0-.4-.2-.4-.4V6.7c0-.2.2-.4.4-.4H16c.2 0 .4.2.4.4v10.5c0 .2-.2.4-.4.4h-1.5z"/><path d="M15.9 6.8v10.4h-1.4V6.8h1.4m.1-1h-1.5c-.5 0-.9.4-.9.9v10.5c0 .5.4.9.9.9H16c.5 0 .9-.4.9-.9V6.7c0-.5-.4-.9-.9-.9z"/></g></svg>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'videoTag',
  props: {
    videoPath: {
      type: Object,
    },
  },
  data() {
    return {
      videoElement: null,
      paused: null,
      end: false,
    };
  },
  computed: {
    playing() { return !this.paused; },
  },
  methods: {
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
    updatePaused2(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
      this.end = false;
    },
    play() {
      this.videoElement.play();
    },
    pause() {
      this.videoElement.pause();
    },
  },
};
</script>

<style scoped lang='stylus'>

.template
  &__video
    display block
    width 100%
    height auto

.controls
  position absolute
  width 100%
  height  100%
  left 0
  top 0
  text-align center
  cursor pointer
  opacity 0
  &_show
    opacity 1
  &:hover
    opacity 1
  &__wrap
    position absolute
    width 100%
    height  100%
    left 0
    top 0
  &__icon
    width 50%
    height auto
    display block
    margin 70% auto 0
    fill #f95504
    -webkit-tap-highlight-color transparent
    outline none
</style>
